export const LOGIN_LOAD_REQUESTED = 'LOGIN_LOAD_REQUESTED';
export const LOGIN_LOAD_SUCCEEDED = 'LOGIN_LOAD_SUCCEEDED';
export const LOGIN_LOAD_FAILED = 'LOGIN_LOAD_FAILED';
export const RENEW_ID_TOKEN = 'RENEW_ID_TOKEN';
export const RENEW_ID_TOKEN_SUCCEEDED = 'RENEW_ID_TOKEN_SUCCEEDED';
export const RENEW_ID_TOKEN_ERROR = 'RENEW_ID_TOKEN_ERROR';
export const RESET_STATE = 'RESET_STATE';
export const SIGN_IN_AS_USER = 'SIGN_IN_AS_USER';
